import ProgressBarComponent from 'app_components/commons/progressBar'
import { CombinedReducers } from 'app_events/index'
import CourseSchedulingEnrollmentService from 'app_services/admin/courseScheduling/courseSchedulingEnrollmentService'
import { EnrollmentStatus } from 'app_types/admin/courseScheduling/courseSchedulingEnrollmentTypes'
import React, {FC, useEffect, useMemo, useState} from 'react'
import { useSelector } from 'react-redux'
import './StudentDashboardCurrentStatus.scss'
import LabelComponent from 'app_components/commons/LabelComponent/LabelComponent'

interface IStudentDashboardCurrentStatusProps {}

const StudentDashboardCurrentStatus: FC<IStudentDashboardCurrentStatusProps>= () => {

  const { courseSelected } = useSelector((state: CombinedReducers) => state.courses)
  const [status, setStatus] = useState<EnrollmentStatus>()
  const enrollmentService = useMemo(() => new CourseSchedulingEnrollmentService(), [])

  const getStatus = async () => {
    if (!courseSelected?.enrollmentId) return
    const response = await enrollmentService.getCurrentStatus({
      enrollmentId: courseSelected?.enrollmentId
    })
    if (response?.code === 200) {
      setStatus(response.currentStatus)
    }
  }

  useEffect(() => {
    getStatus()
  }, [courseSelected?.enrollmentId])

  const getTitle = () => {
    if (status === EnrollmentStatus.REGISTERED) {
      return "Inscrito"
    }
    if (status === EnrollmentStatus.IN_PROGRESS) {
      return "Iniciado"
    }
    if (status === EnrollmentStatus.COMPLETED) {
      return "Finalizado"
    }
    if (status === EnrollmentStatus.CERTIFIED) {
      return "Certificado"
    }
    return '0%'
  }

  const getProgressBarColor = (statusToGet: EnrollmentStatus) => {
    if (status==='certified'){
      return "var(--success)"
    }
    const orderStatus = [
      EnrollmentStatus.REGISTERED,
      EnrollmentStatus.IN_PROGRESS,
      EnrollmentStatus.COMPLETED,
      EnrollmentStatus.CERTIFIED,
    ]
    const currentIdx = orderStatus.findIndex((statusToEvaluate) => statusToEvaluate === status)
    const statusIdx = orderStatus.findIndex((statusToEvaluate) => statusToEvaluate === statusToGet)
    if (statusIdx <= currentIdx) {
      return "var(--primary)"
    }
    return "var(--gray-400)"
  }

  return (
    status ?
    <div className='student-dashboard-current-status--layout'>
      <div className='student-dashboard-current-status--bars-container'>
        <ProgressBarComponent background={getProgressBarColor(EnrollmentStatus.REGISTERED)} progress='100%' />
        <ProgressBarComponent background={getProgressBarColor(EnrollmentStatus.IN_PROGRESS)} progress='100%' />
        <ProgressBarComponent background={getProgressBarColor(EnrollmentStatus.COMPLETED)} progress='100%' />
        <ProgressBarComponent background={getProgressBarColor(EnrollmentStatus.CERTIFIED)} progress='100%' />
      </div>
      <LabelComponent>{getTitle()}</LabelComponent>
    </div> : null
  )
}

export default StudentDashboardCurrentStatus
